<template>
  <button
    class="delete-access"
    :disabled="loading"
    @click="handleDestroy()"
  >
    <i class="fa fa-trash-o mr-1" style="font-size: 18px;"></i> {{ __(message) }}
  </button>
</template>

<script>
export default {
  props: ['user'],

  data () {
    return {
      loading: false,
    };
  },

  computed: {
    message () {
      if (this.loading) {
        return 'Aguarde...';
      }

      return 'Remover acesso';
    },
  },

  methods: {
    handleDestroy () {
      this.loading = true;

      this.$http.get(`/user/${this.user.id}/aggregates`).then(({ data }) => {
        const { leads, deals } = data;

        const user = {
          ...this.user,
          leads,
          deals,
        };

        Bus.$emit('openModalUserDestroy', user);
      }).catch((error) => {
        console.error(error);
        Alert.error('Falha ao deletar usuário!')
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../sass/variables.scss';

  .delete-access {
    font-weight: 600;
    background: transparent;
    padding: 0px;
    border: 0px;
    outline: 0px;

    &:hover {
      cursor: pointer;
      color: $salesflow-primary-hover !important;
      text-decoration: none !important;
    }

    &:disabled {
      cursor: not-allowed;
    }
  }
</style>
